<template>
  <div>
    <!--container-->
    <v-container>
      <!--tob bar-->
      <bar />
      <!--tob bar end-->

      <!--template-->
      <template>
        <!--card -->
        <v-card class="form-card mx-auto my-12">
          <!--alert box-->
          <v-alert text prominent type="error" v-if="errorResponse">
            <div v-for="(error, i) in segmentError" :key="i">
              {{ error }}
            </div>
          </v-alert>
          <!--alert box end-->
          <v-list-item class="headline">
            <v-list-item-content>
              <v-list-item-title>
                SEGMENT
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <!--form-->
          <form>
            <!--input field-->
            <v-card-text>
              <v-row justify="space-between">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="segmentname"
                    :value="segmentname"
                    :error-messages="segmentnameErrors"
                    label="SEGMENT NAME*"
                    required
                    @input="$v.segmentname.$touch()"
                    @blur="$v.segmentname.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <!--input field end-->
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="black" dark @click="submit"> SUBMIT </v-btn>
              <v-btn color="warning" dark to="/segment"> CANCEL </v-btn>
            </v-card-actions>
          </form>
          <!--form end-->
        </v-card>
        <!--card end-->
      </template>
      <!--template end-->
    </v-container>
    <!--container end-->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "SegmentEdit",
  data: () => ({}),
  validations: {
    segmentname: { required }
  },
  computed: {
    ...mapGetters([
      "segmentStatus",
      "segmentStatusResponse",
      "segmentDetailsname"
    ]),
    segmentnameErrors() {
      const errors = [];
      if (!this.$v.segmentname.$dirty) return errors;
      !this.$v.segmentname.required && errors.push("LOB Name is required.");
      return errors;
    },
    errorResponse: function() {
      return this.segmentStatus === "error";
    },
    segmentError: function() {
      return this.segmentStatusResponse;
    },
    segmentname: {
      get() {
        return this.segmentDetailsname;
      },
      set(value) {
        this.$store.commit("updateSegmentname", value);
      }
    }
  },
  created() {
    this.fetchSegmentdetails(this.$route.params.id);
  },

  methods: {
    ...mapActions(["segmentUpdate", "fetchSegmentdetails"]),
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("ERROR");
      } else {
        // do your submit logic here
        setTimeout(() => {
          const segmentData = {
            segmentId: this.$route.params.id,
            segmentName: this.segmentname.toUpperCase()
          };
          console.log(segmentData);
          this.segmentUpdate(segmentData);
          //console.log(productgroupData);
        }, 500);
      }
    }
  }
};
</script>
